import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const tfnTestingToolPlugin = createPlugin({
  id: 'tfn-testing-tool',
  routes: {
    root: rootRouteRef,
  },
});

export const TfnTestingToolPage = tfnTestingToolPlugin.provide(
  createRoutableExtension({
    name: 'TfnTestingToolPage',
    component: () => import('./components/App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
